module.exports = __webpack_public_path__ + "static/media/Chapter 3 Slide 1-4.c0250bed.jpg";